import { motion } from 'framer-motion'
import Form from '../components/Form'
import SEO from '../utils/seo'

const Contact = () => {
  return (
    <>
      <SEO
        title="Contact"
        description="Get in touch with Prompted Thoughts. Whether you're a listener, potential guest, or sponsor, we'd love to hear from you."
      />

      <div className="section">
        <div className="container-custom max-w-3xl">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <h1 className="text-4xl md:text-5xl font-bold text-off-white mb-4">Get in Touch</h1>
            <p className="text-lg text-gray-400">
              Whether you're a listener, potential guest, or sponsor, we'd love to hear from you
            </p>
          </motion.div>

          {/* Contact reasons */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="grid md:grid-cols-3 gap-6 mb-12"
          >
            {[
              {
                icon: '🎤',
                title: 'Be a Guest',
                description: 'Share your AI building experience with our community',
              },
              {
                icon: '💼',
                title: 'Sponsorship',
                description: 'Reach engaged developers and technical leaders',
              },
              {
                icon: '💬',
                title: 'Feedback',
                description: 'Questions, suggestions, or just want to say hi',
              },
            ].map((item) => (
              <div
                key={item.title}
                className="bg-slate/40 backdrop-blur-sm rounded-lg p-6 text-center border border-slate"
              >
                <div className="text-4xl mb-3">{item.icon}</div>
                <h3 className="text-lg font-bold text-off-white mb-2">{item.title}</h3>
                <p className="text-sm text-gray-400">{item.description}</p>
              </div>
            ))}
          </motion.div>

          {/* Contact form */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="bg-slate/20 backdrop-blur-sm rounded-lg p-8 border border-slate"
          >
            <h2 className="text-2xl font-bold text-off-white mb-6 text-center">Send us a message</h2>
            <Form type="contact" />
          </motion.div>

          {/* Alternative contact */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.6 }}
            className="mt-12 text-center"
          >
            <p className="text-gray-400 mb-4">You can also reach us directly:</p>
            <a
              href="mailto:hello@promptedthoughts.dev"
              className="text-cyan hover:text-cyan/80 text-lg font-medium gradient-underline"
            >
              hello@promptedthoughts.dev
            </a>
          </motion.div>
        </div>
      </div>
    </>
  )
}

export default Contact
